import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import logo from 'Assets/Login Logo.png';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import SecurityIcon from '@material-ui/icons/Security';
import styles from './QuickUserWelcome.module.css';

export const QuickUserWelcome = () => {
  const navigate = useNavigate();

  const handleSeeMyContent = () => {
    window.open(`${Pathname.yourVideos}?quickUserModal=1`, '_blank');
  };

  const handleExplorePlans = () => {
    window.location.href = 'https://www.projectorstream.com/';
  };

  return (
    <div className={styles.pageContainer}>
      {/* Background accents */}
      <div className={styles.bgOverlay}>
        <div className={styles.bgAccent1} />
        <div className={styles.bgAccent2} />
        <svg className={styles.bgRingSvg} viewBox="0 0 600 600">
          <circle
            className={styles.bgRingCircle}
            cx="300"
            cy="300"
            r="299"
          />
        </svg>
      </div>

      <div className={styles.contentWrapper}>
        {/* Header */}
        <div className={styles.header}>
          <Link to={Pathname.home}>
            <img
              src={logo}
              alt="Projector Logo"
              className={styles.logo}
            />
          </Link>
        </div>

        {/* Title */}
        <div className={styles.titleSection}>
          <h1 className={styles.title}>Congrats, your account is ready</h1>
          <p className={styles.subtitle}>See your content now or discover how to protect and grow your memories</p>
        </div>

        {/* Cards */}
        <div className={styles.cardsGrid}>
          {/* Card 1: See My Content Now */}
          <div className={styles.primaryCard}>
            <div className={styles.primaryIconWrapper}>
              <PlayArrowIcon style={{ fontSize: '1.5rem', color: '#22d3ee' }} />
            </div>
            <h2 className={styles.cardTitle}>See My Content Now</h2>
            <ul className={styles.featureList}>
              <li className={styles.featureItem}>
                <CheckCircleOutlineIcon className={styles.primaryFeatureIcon} />
                <span className={styles.featureText}>Your Media is ready</span>
              </li>
              <li className={styles.featureItem}>
                <CheckCircleOutlineIcon className={styles.primaryFeatureIcon} />
                <span className={styles.featureText}>Safe, private, instant access</span>
              </li>
              <li className={styles.featureItem}>
                <CheckCircleOutlineIcon className={styles.primaryFeatureIcon} />
                <span className={styles.featureText}>Delivered by your trusted Affiliate</span>
              </li>
              <li className={styles.featureItem}>
                <CheckCircleOutlineIcon className={styles.primaryFeatureIcon} />
                <span className={styles.featureText}>Watch on any device including your TV</span>
              </li>
            </ul>
            <button
              onClick={handleSeeMyContent}
              className={styles.primaryCta}
            >
              See My Content Now
              <ArrowForwardIcon className={styles.ctaArrow} />
            </button>
          </div>

          {/* Card 2: Protect & Grow My Memories */}
          <div className={styles.secondaryCard}>
            <div className={styles.secondaryIconWrapper}>
              <SecurityIcon style={{ fontSize: '1.5rem', color: '#94a3b8' }} />
            </div>
            <h2 className={styles.cardTitle}>Protect & Grow My Memories</h2>
            <ul className={styles.featureList}>
              <li className={styles.featureItem}>
                <CheckCircleOutlineIcon className={styles.secondaryFeatureIcon} />
                <span className={styles.featureText}>Keep your Media safe & accessible</span>
              </li>
              <li className={styles.featureItem}>
                <CheckCircleOutlineIcon className={styles.secondaryFeatureIcon} />
                <span className={styles.featureText}>Add storage, streaming, and more</span>
              </li>
              <li className={styles.featureItem}>
                <CheckCircleOutlineIcon className={styles.secondaryFeatureIcon} />
                <span className={styles.featureText}>Most customers choose to back up their videos after watching</span>
              </li>
            </ul>
            <button
              onClick={handleExplorePlans}
              className={styles.secondaryCta}
            >
              Find Out How
              <ArrowForwardIcon className={styles.ctaArrow} />
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};
